import LeafTileValue from "../../../../../common/leaf/LeafTileValue/LeafTileValue";
import "./MetricCard.scss";

interface Props {
  items: { label: string; value: string }[];
}

export const MetricCard = ({ items }: Props) => {
  return (
    <div className="metric-card">
      {items.map((item, index) => (
        <div key={index} className="metric-card__item">
          <LeafTileValue title={item.label} value={item.value} isLoading={false} id={`"metric_${item.value}"`} />
        </div>
      ))}
    </div>
  );
};
